import 'css-chunksrc/client/pages/zonesPage/reportsPage/report/styles.scss';export default {
  "report": "_report_8xkdo_1",
  "nameBox": "_nameBox_8xkdo_19",
  "folderIcon": "_folderIcon_8xkdo_27",
  "projectName": "_projectName_8xkdo_35",
  "separator": "_separator_8xkdo_44",
  "reportName": "_reportName_8xkdo_49",
  "row": "_row_8xkdo_55",
  "label": "_label_8xkdo_62",
  "author": "_author_8xkdo_68",
  "authorAvatar": "_authorAvatar_8xkdo_76",
  "authorName": "_authorName_8xkdo_84",
  "text": "_text_8xkdo_89",
  "indicators": "_indicators_8xkdo_94"
};